import { useUiStore } from '@/stores';
import { MODES } from '@/stores/ui';

export default defineNuxtPlugin(() => {
  const { setMode } = useUiStore();
  const { userAgent } = navigator;

  // Matches strings with the format: dahl-app-vX.Y.Z, where X,Y,Z is numeric
  const pattern = /^dahl-app-v(\d+\.)?(\d+\.)?(\d+)/;
  const dahlAppStringMatcher = new RegExp(pattern, 'g');
  const isAppUser = dahlAppStringMatcher.test(userAgent);

  if (isAppUser) {
    setMode({ mode: MODES.APP });
  }
});
